module.exports = __webpack_public_path__ + "img/negado.838cacf5.png";